

import Config from '../../src/config.js';
var u = navigator.userAgent;
export default {
    H5key:'O2018@(*cbctcbct*)@8102O',
    isAndroid: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,
    isIOS: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
    // 安卓下载地址
    downLoadAndroid:function(){
        var ua = navigator.userAgent.split("(")[1].split(")")[0];
        var phone = [/IPHONE/gi, /huawei/gi, /mi/gi, /vivo/gi, /OPPO/gi, /samsung/gi, /SONY/gi, /Nokia/gi, /HTC/gi, /ZTE/gi, /Lenovo/gi, /ZUK/gi,]
        if (phone[1].test(ua)) {
            window.location.href='https://appgallery.cloud.huawei.com/uowap/index.html#/detailApp/C100594819?source=appshare&subsource=C100594819';
        } else if (phone[2].test(ua)) {
            window.location.href='http://app.xiaomi.com/detail/760715';
        } else if (phone[3].test(ua)) {
            window.location.href='http://appdetailh5.vivo.com.cn/detail/2418329?source=7';
        } else if (phone[4].test(ua)) {
            window.location.href='http://appdetailh5.vivo.com.cn/detail/2418329?source=7';
        } else {
            window.location.href = 'http://img001.cbct.cn/package/SFM_M_A_S_cbct.apk';
        }
    },
    //  ios下载地址
    downLoadIos:function(){
        window.location = "https://itunes.apple.com/us/app/id1439524045?ls=1&mt=8";
    },
    //根据时间返回星期几
    getWeek:function(timestamp){
        var weekArray = new Array("日", "一", "二", "三", "四", "五", "六");
        var week = weekArray[new Date().getDay()];
        var date =new Date(timestamp*1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000  
        var timer = ''; 
        var Y = date.getFullYear();    
        var M = (date.getMonth() +1 <10 ?'0' + (date.getMonth() +1) : date.getMonth() +1);    
        var D = date.getDate()<10 ?'0' +date.getDate():date.getDate();    
        var da = Y+'-'+M+'-'+D;
        var week = '星期'+weekArray[new Date(da).getDay()];//注意此处必须是先new一个Date
        return week;
    },
    //判断是否同一天，昨天，前天
    timestampToTimes:function(timestamp) {
        var date =new Date(timestamp*1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000  
        var timer = ''; 
        var Y = date.getFullYear();    
        var M = (date.getMonth() +1 <10 ?'0' + (date.getMonth() +1) : date.getMonth() +1);    
        var D = date.getDate()<10 ?'0' +date.getDate():date.getDate();    
        var h = date.getHours()<10 ?'0' + date.getHours():date.getHours();    
        var m = date.getMinutes()<10?'0' + date.getMinutes():date.getMinutes();    
        var s = date.getSeconds();
        var data1 =  new Date(Date.parse(new Date()));
        var Y1 = data1.getFullYear();    
        var M1 = (data1.getMonth() +1 <10 ?'0' + (data1.getMonth() +1) : data1.getMonth() +1);    
        var D1 = data1.getDate()<10 ?'0' +data1.getDate():data1.getDate();    
        var h1 = data1.getHours()<10 ?'0' + data1.getHours():data1.getHours();    
        var m1 = data1.getMinutes()<10?'0' + data1.getMinutes():data1.getMinutes();    
        var s1 = data1.getSeconds();

        console.log(Date.parse(new Date()))
        const date2 = new Date();
	    const year2 = date2.getFullYear();
	    const month2 = date2.getMonth() + 1;
	    const day2 = date2.getDate();
	    const today2 = `${year2}/${month2}/${day2}`; 
        const todayTime2 = new Date(today2).getTime(); // 当天凌晨的时间
        const yesterdayTime = new Date(todayTime2 - 24 * 60 * 60 * 1000).getTime(); // 昨天凌晨的时间
        const yesterdayTime2 = new Date(todayTime2 - 48 * 60 * 60 * 1000).getTime(); // 昨天凌晨的时间
        //  time < todayTime2 && yesterdayTime2 <= time;
        if(timestamp*1000>todayTime2){
            timer = 'yes';
            if((Date.parse(new Date()))/1000 - timestamp > 3600){
                timer = m+':'+s;
            }

        }
        else if(timestamp*1000<todayTime2 && timestamp*1000>yesterdayTime){
            timer = '昨天';
        }
        else if(timestamp*1000<yesterdayTime && timestamp*1000>yesterdayTime2){
            timer = '前天';
        }else{
            timer = 'no'
        }
        return timer;
    },
    //返回回放时间
    timestampToTime:function(timestamp) {
        var date =new Date(timestamp*1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000  
        var timer = ''; 
        var Y = date.getFullYear();    
        var M = (date.getMonth() +1 <10 ?'0' + (date.getMonth() +1) : date.getMonth() +1);    
        var D = date.getDate()<10 ?'0' +date.getDate():date.getDate();    
        var h = date.getHours()<10 ?'0' + date.getHours():date.getHours();    
        var m = date.getMinutes()<10?'0' + date.getMinutes():date.getMinutes();    
        var s = date.getSeconds();
        var data1 =  new Date(Date.parse(new Date()));
        var Y1 = data1.getFullYear(); 
        var M1 = (data1.getMonth() +1 <10 ?'0' + (data1.getMonth() +1) : data1.getMonth() +1);    
        var D1 = data1.getDate(); 
        if(data1/1000-timestamp<=3600*24*7){
            timer =h+':'+m;
        }else{
            if(Y1!=Y){
                timer = Y+'年'+M+'月'+D+'日'+' ' +h+':'+m;
            }else{
                timer = M+'月'+D+'日'+' ' +h+':'+m;
            }
            
        }
        return timer;
    },
  
    https:function(){
       return Config.apiUrl;
    },
    dsUrl:function(){
        return Config.dsUrl;
     },
    imgUrl:function(){
        return Config.imgUrl;
    },
    imgUrlAvatar:function(){
        return Config.imgUrlAvatar;
    },
    prefixAvatar:function(){
        return Config.prefixAvatar;
    },
    imgUrlImg:function(){
        return Config.imgUrlImg;
    },
    baseurl:Config.apiUrl,
    isInteger: function (num){
        var regu = /^[1-9]\d*$/;
        return !regu.test(num)?false:true;
    },
    isRealNum: function(val){  
        // isNaN()函数 把空串 空格 以及NUll 按照0来处理 所以先去除    
        if(val === "" || val == null){        
            return false;    
        }    
        if(!isNaN(val)){
            return true;    
        }else{        
            return false;    
        }
    },         
    trim:function (str) {
        return str.replace(/(^\s*)|(\s*$)/g, "");
    },
    getUrlParms:function () { 
        var args = new Object();
        var query = location.search.substring(1);//获取查询串
        var pairs = query.split("&");//在逗号处断开
        for (var i = 0; i < pairs.length; i++) {
            var pos = pairs[i].indexOf('=');//查找name=value
            if (pos == -1) continue;//如果没有找到就跳过
            var argname = pairs[i].substring(0, pos);//提取name
            var value = pairs[i].substring(pos + 1);//提取value
            // args[argname]=unescape(value);//存为属性
            args[argname] = decodeURIComponent(unescape(value));//存为属性
        }
        return args;
    },
    code:{
        successCode:200
    },
    androidDownloadAddress:Config.androidDownloadAddress,
    iosDownloadAddress:Config.iosDownloadAddress,
    formatDate:function (date, fmt) {
        if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, 
                    (date.getFullYear() + '').substr(4 - RegExp.$1.length));
        }
        let o = {
            'M+': date.getMonth() + 1,
            'd+': date.getDate(),
            'h+': date.getHours(),
            'm+': date.getMinutes(),
            's+': date.getSeconds()
        };
        for (let k in o) {
            if (new RegExp(`(${k})`).test(fmt)) {
                let str = o[k] + '';
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? 
                str : ('00' + str).substr(str.length));
            }
        }
        return fmt;
    },

}
